import type { Directive } from 'vue';

export default {
	params: [
		'focus',
	],
	// TODO: fix model
	mounted(el, bindings) {
		if (!Object.prototype.hasOwnProperty.call(bindings, 'value') || bindings.value) {
			el.focus();
		}
	},
} as Directive<HTMLElement>;
